// extracted by mini-css-extract-plugin
module.exports = {"checkboxWrapper":"styles_checkboxWrapper__1J0tB","warningMsg":"styles_warningMsg__tR1d0","agreeTxt":"styles_agreeTxt__1Yj0h","checkboxLabel":"styles_checkboxLabel__1Khj4"};